export default __webpack_public_path__ + "static/media/lateral.464cffe8.svg";